export default "__VITE_ASSET__DHG5Q6t___"